export default "__VITE_ASSET__DEPt9NIz__"